export enum INSPECTION_CREATION_OPTION {
  UPDATE_DEALER_INFORMATION = 'updateDealerInformation',
  UPDATE_VEHICLE_INFORMATION = 'updateVehicleInformation',
  UPDATE_SCHEDULING_INFORMATION = 'updateSchedulingInformation',
}
